import uploadsscholarshipssidebyside01imageshutterstock_2430940381Jpg from "$lib/data/generated/uploads/scholarships/SideBySide 01/image/shutterstock_2430940381.jpg?as=run";

export const uploads = {
  "uploads/scholarships/SideBySide 01/image/shutterstock_2430940381.jpg": uploadsscholarshipssidebyside01imageshutterstock_2430940381Jpg
};